import React from "react";
import PolicyPageLayout, { PolicyList, PolicySection } from "./PolicyPageLayout";
import { COMPANY_DETAILS } from "./policyData";

const WarrantyPolicy = () => {
  return (
    <PolicyPageLayout
      title="Warranty Policy"
      subtitle="This policy explains the limited warranty support available on eligible refurbished products, replacement parts and repair work completed by our team."
    >
      <PolicySection title="1. Warranty Coverage">
        <p>
          We may provide a limited warranty on select refurbished products,
          replacement parts and repair services. Exact coverage, duration and
          exclusions are mentioned on the invoice, job sheet or service bill and
          that document will prevail for the specific transaction.
        </p>
      </PolicySection>

      <PolicySection title="2. Typical Warranty Duration">
        <PolicyList
          items={[
            "Refurbished laptops or desktops: up to 3 months.",
            "Replacement parts supplied by us: up to 1 month.",
            "Repair services performed by our technicians: up to 15 days.",
          ]}
        />
      </PolicySection>

      <PolicySection title="3. What Is Covered">
        <PolicyList
          items={[
            "Hardware defects in the parts supplied and installed by us.",
            "Faults directly arising from repair work carried out by our technicians.",
            "Improper installation or configuration done by our authorised service team.",
          ]}
        />
      </PolicySection>

      <PolicySection title="4. What Is Not Covered">
        <PolicyList
          items={[
            "Physical damage, liquid damage, electrical surge or accidental damage.",
            "Virus, malware, software corruption, OS issues or data-related problems unless expressly covered in writing.",
            "Battery backup deterioration, cosmetic wear, cables, chargers or accessories treated as normal wear and tear.",
            "Damage caused by misuse, negligence, unauthorised opening, tampering or third-party repair.",
          ]}
        />
      </PolicySection>

      <PolicySection title="5. How to Claim Warranty">
        <PolicyList
          items={[
            "Report the issue within the applicable warranty period.",
            "Share the original invoice, bill or service reference.",
            "Bring or send the product for inspection if asked by our team.",
            "Describe the issue clearly and share photos or videos if requested by our support team.",
          ]}
        />
        <p>
          Warranty service is provided only after inspection confirms that the
          issue falls within the covered scope.
        </p>
      </PolicySection>

      <PolicySection title="6. Repair or Replacement Decision">
        <p>
          If a claim is approved, we may repair the item, replace the faulty
          component, provide an equivalent refurbished replacement, or offer
          another commercially reasonable resolution depending on stock and
          technical feasibility.
        </p>
      </PolicySection>

      <PolicySection title="7. Data Responsibility">
        <p>
          Customers must back up all data before handing over any device for
          repair, diagnosis or warranty claim. We are not responsible for data
          loss, corruption or software downtime during repair, testing or parts
          replacement.
        </p>
      </PolicySection>

      <PolicySection title="8. Out-of-Warranty Service">
        <p>
          If inspection shows that the issue is outside warranty coverage, any
          paid repair or replacement will be done only after your approval of
          the applicable charges.
        </p>
      </PolicySection>

      <PolicySection title="9. Contact for Warranty Support">
        <PolicyList
          items={[
            `${COMPANY_DETAILS.name}`,
            `Email: ${COMPANY_DETAILS.email}`,
            `Phone: ${COMPANY_DETAILS.phone}`,
            `Address: ${COMPANY_DETAILS.address}`,
            `Support hours: ${COMPANY_DETAILS.supportHours}`,
          ]}
        />
      </PolicySection>
    </PolicyPageLayout>
  );
};

export default WarrantyPolicy;
